export default __webpack_public_path__ + "static/media/1951.11a103bd.png";